<template>
  <v-dialog
    persistent
    v-model="display"
    max-width="350"
  >
    <v-card
      style="border-radius: 24px"
    >
      <v-card-title>
        {{ title }}
      </v-card-title>
      <v-card-text
        v-html="message">
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          text
          @click="callback(); display = false"
        >
          {{ buttonName }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    title: '',
    message: '',
    buttonName: '',
    callback: () => {},
    display: false,
  }),
  methods: {
    show(title, message, buttonName, callback) {
      this.title = title
      this.message = message
      this.buttonName = buttonName
      if (typeof(callback) == 'function') {
        this.callback = callback
      }
      this.display = true
    },
  },
};
</script>
